var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("signBlockList"),_vm._l((_vm.numPages),function(page){return _c('canvas',{key:page,ref:`the-canvas${page}`,refInFor:true})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }